
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cpu",
      function () {
        return require("private-next-pages/cpu/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cpu"])
      });
    }
  